// extracted by mini-css-extract-plugin
export default {"laundryConfirmation":"thankYou_laundryConfirmation__I3rYj"};